// extracted by mini-css-extract-plugin
export var circle = "_35-2";
export var icon = "_35-a";
export var iconHighlight = "_35-0";
export var lg = "_35-8";
export var md = "_35-7";
export var outline = "_35-4";
export var sm = "_35-6";
export var square = "_35-1";
export var xl = "_35-9";
export var xs = "_35-5";
export var xxs = "_35-3";